import { StepsButtons } from "@/components/button/steps-button";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { PageTitleComponent } from "@/components/page-title";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { useIonRouter } from "@ionic/react";
import SupermarketSelectionList from "../../components/supermarket-selection-list";
import { useSupermarket } from "../../hooks/use-supermarket";

export default function OnboardingSupermarket() {
  const { info } = useStepRouteInfo();
  const navigation = useIonRouter();
  const {
    handlePreferenceSelect,
    handleSubmit,
    isLoading,
    options,
    selectedOptions,
    isUpdating,
  } = useSupermarket({
    onSuccess: () => {
      navigation.push(info?.nextPath ?? "", "none");
    },
  });

  return (
    <ProfilePageContainer>
      <PageTitleComponent
        title="Which supermarket you shop at?"
        description="We’ll tailor your companion around the places you already go."
        className="mt-2 mb-6 w-full"
      />

      <SupermarketSelectionList
        isLoading={isLoading}
        options={options ?? []}
        selectedPreference={selectedOptions}
        handlePreferenceSelect={handlePreferenceSelect}
      />

      <StepsButtons
        previousPath={info?.previousPath}
        type="button"
        disabled={isLoading || isUpdating}
        onClick={handleSubmit}
      />
    </ProfilePageContainer>
  );
}
